// extracted by mini-css-extract-plugin
module.exports = {"main":"blog-post-module--main--3jFRr","imageContainer":"blog-post-module--imageContainer--1-DNr"};